import { useLogout } from "@/hooks/data/useLogout"
import { usePlatform } from "@/platform/context"
import { Link, Outlet, useLocation } from "react-router"
import { ThemeToggle } from "../components/theme-toggle"
import { Button } from "../components/ui/button"
import { useAuth } from "../providers/auth"

export const Layout = () => {
	const { status, user } = useAuth()
	const platform = usePlatform()
	const location = useLocation()
	const { mutate: logout } = useLogout()
	const searchParams = new URLSearchParams(location.search)
	const isMacShell =
		platform.kind === "electron" || searchParams.get("origin") === "mac"
	const redirectParam =
		location.pathname === "/"
			? ""
			: `?redirect=${encodeURIComponent(location.pathname)}`

	return (
		<div
			className={
				isMacShell
					? "flex h-full min-h-0 flex-col bg-transparent overscroll-none"
					: "flex min-h-screen flex-col bg-background"
			}
		>
			{!isMacShell && (
				<header className="flex items-center justify-between p-4">
					<div className="flex items-center gap-2">
						<h1>Oblique</h1>
						<Button variant="ghost" asChild>
							<Link to="/download">Download</Link>
						</Button>

						{status === "authenticated" && (
							<Button variant="ghost" asChild>
								<Link to="/dashboard">Dashboard</Link>
							</Button>
						)}
					</div>

					<nav className="flex items-center gap-2">
						{status === "authenticated" && user ? (
							<>
								<span className="text-sm text-muted-foreground">
									{user.email}
								</span>
								<Button variant="ghost" onClick={() => logout()}>
									Log out
								</Button>
							</>
						) : (
							<>
								<Button variant="ghost" asChild>
									<Link to={`/login${redirectParam}`}>Login</Link>
								</Button>
								<Button asChild>
									<Link to={`/register${redirectParam}`}>Register</Link>
								</Button>
							</>
						)}
						<ThemeToggle />
					</nav>
				</header>
			)}

			<main
				className={
					isMacShell
						? "flex min-h-0 flex-1 overflow-auto"
						: "flex flex-1 items-center justify-center"
				}
			>
				<Outlet />
			</main>
		</div>
	)
}
